/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import _ from 'lodash';

import DropdownArrow from 'components/images/DropdownArrow';
import { LanguageWithCountryCodeOption, LanguageWithCountryCode, TranslatedLanguageWithCountryCodeOption, TranslatedLanguageWithCountryCode } from 'components/localization';
import listLocaleSelector from 'redux/reduxStore/lists/listLocale';

function mapStateToProps(state) {
  const localeList = listLocaleSelector.getCollection(state);
  return {
    localeList,
    getLocale: (localeId) => {
      return localeList.filter(l => l.id === localeId)[0] || {}
    }
  };
}

function compareLocale(intl, a, b) {
  return intl.formatMessage({ id: `${a.key}.name` }).localeCompare(intl.formatMessage({ id: `${b.key}.name` }));
}

function getReducedAndSortedList(intl, localeList, excludeLanguageCodes) {
  return localeList.filter(l => !_.includes(excludeLanguageCodes, l.language_code)).sort((a, b) => compareLocale(intl, a, b));
}

function withListLocale(SelectInputComponent) {
  class DropdownWithLocale extends React.Component {
    UNSAFE_componentWillMount() {
      if (this.props.localeList.filter(l => l.id === this.props.value).length === 0) {
        const localeList = getReducedAndSortedList(this.props.intl, this.props.localeList, this.props.excludeLanguageCodes);
        const firstLocale = localeList[0];
        this.props.onChange(firstLocale.id, firstLocale);
      }
    }

    render() {
      const OptionComponent = this.props.isNamesTranslated ? TranslatedLanguageWithCountryCodeOption : LanguageWithCountryCodeOption;
      const LanguageComponent = this.props.isNamesTranslated ? TranslatedLanguageWithCountryCode : LanguageWithCountryCode;
      const localeList = getReducedAndSortedList(this.props.intl, this.props.localeList, this.props.excludeLanguageCodes);
      const options = localeList.map((v) => <OptionComponent key={v.id} locale={v} isDisabled={false} />);
      const locale = this.props.getLocale(this.props.value);

      return (
        <SelectInputComponent
          displayValue={<LanguageComponent locale={locale} />}
          value={this.props.value}
          {...this.props}
          options={options}
          onChange={(value) => {
            const id = Number(value);
            this.props.onChange(id, this.props.getLocale(id));
          }}
        />
      );
    }
  }
  DropdownWithLocale.propTypes = {
    onChange: PropTypes.func,
    localeList: PropTypes.array,
    value: PropTypes.number,
    excludeLanguageCodes: PropTypes.array,
    isNamesTranslated: PropTypes.bool,
  };
  DropdownWithLocale.defaultProps = {
    excludeLanguageCodes: [],
  };

  return connect(mapStateToProps)(injectIntl(DropdownWithLocale));
}

export default withListLocale;
